import { render, staticRenderFns } from "./ActionDesarmarEquipo.vue?vue&type=template&id=5e820182&lang=pug"
import script from "./ActionDesarmarEquipo.vue?vue&type=script&lang=js"
export * from "./ActionDesarmarEquipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports